import { render, staticRenderFns } from "./AcctNoUOBHelpList.vue?vue&type=template&id=12a69963&"
import script from "./AcctNoUOBHelpList.vue?vue&type=script&lang=js&"
export * from "./AcctNoUOBHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports